export default "__VITE_ASSET__66caea0f__"